export const PROFILE_SET = '[PROFILE] set data';
export const PROFILE_SET_PUBLISHER = '[PROFILE] set publisher';
export const PROFILE_SET_NAME = '[PROFILE] set name';
export const PROFILE_SET_CHECKOUTS = '[PROFILE] set checkouts';



// WEBPACK FOOTER //
// ./src/profile/constants/ActionTypes.ts